<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title + ' - ' + namaCompany" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <form @submit.prevent="insert">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between ">
                      <label>Employee <span class="text-danger">*</span></label>
                    </div>
                    <!-- <model-select :options="data_marketing" placeholder="Select Marketing"
                      v-model="this.currentData.id_marketing" style="z-index:500" :isError="marketingCek">
                    </model-select> -->
                    <multi-select :options="needData1" :selected-options="employees" style="z-index:504"
                      placeholder="select Employee" @select="onSelectEmployees">
                    </multi-select>
                  </div>
                </div>

                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label>Date <span class="text-danger">*</span></label>
                    <div class="input-groupicon" style="z-index: 100;">
                      <datepicker v-model="currentData.tanggal" class="picker" :editable="true" :clearable="false"
                        required />
                      <a class="addonset">
                        <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                      </a>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Time Start<span class="text-danger">*</span></label>
                    <input type="time" id="jam_masuk" name="jam_masuk" v-model="currentData.jam_mulai">
                  </div>
                </div>

                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Time End<span class="text-danger">*</span></label>
                    <input type="time" id="jam_keluar" name="jam_keluar" v-model="currentData.jam_selesai">
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <label>Reason<span class="text-danger">*</span></label>
                    <textarea type="text" v-model="currentData.alasan" rows="2" placeholder=""></textarea>
                  </div>
                </div>
                

                <div class="col-lg-12">
                  <button type="submit" class="btn btn-submit me-2">Save</button>
                  <router-link to="overtime" class="btn btn-cancel">Cancel</router-link>
                </div>
              </div>

            </form>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-group input[type="datetime-local"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="time"] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #637381;
  padding: 10px 15px;
  border-radius: 5px;
}

.form-group input[type="datetime-local"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}

.form-group input[type="time"]:focus {
  border: 1px solid rgba(82, 183, 127, 255);

}
</style>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, goPage, AlertBottom, appendForm, timeout, selectedBranch, rupiahInput, rupiahoutput } from "@/assets/js/function";
import { ModelSelect, MultiSelect } from 'vue-search-select';

export default {
  components: {
    ModelSelect,
    MultiSelect
  },
  name: "addovertime",
  data() {
    return {
      filter: true,
      title: "Insert Overtime",
      title1: "Add new overtime",
      namaCompany: '',
      config: "",
      api: "",
      value: "",
      //data
      currentData: {
        tanggal: new Date(),
        jam_mulai: '00:00',
        jam_selesai: '00:00',
        alasan: '',
      },
      currentDate: new Date,
      needData1: [],
      needData2: [],
      employees: [],
      lastSelectItemEmployee: {},
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'insert')
    
    this.namaCompany = localStorage.getItem('namaCompany');

    this.getEmployees();

  },
  methods: {
    formatCurrency(name) {
        this.currentData[name] = rupiahInput(this.currentData[name]);
    },
    
    onSelectLocations(items, lastSelectItem) {
      this.locations = items
      this.lastSelectItemLocation = lastSelectItem
    },
    onSelectEmployees(items, lastSelectItem) {
      this.employees = items
      this.lastSelectItemEmployee = lastSelectItem
    },
    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    getEmployees() {

      const needData1 = JSON.parse(localStorage.getItem('employeeList'));
      needData1.forEach((item, index) => {
        const item_prepare = { value: item.id, text: item.nama + ' (' + item.telepon + ')' };
        this.needData1.push(item_prepare);
      });

        
    },

    formatDateLocal(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    },

    async insert() {
      
      if (!this.currentData.jam_mulai || !this.currentData.jam_selesai) {
        alert('Jam mulai dan jam selesai wajib diisi.');
        CloseLoading();
        return;
      }
      if (!this.currentData.alasan || this.currentData.alasan.trim() === '') {
        alert('Alasan lembur wajib diisi.');
        CloseLoading();
        return;
      }
      let formData = new FormData();
      appendForm(formData)

      formData.delete('jam_mulai');
      formData.append('jam_mulai', this.currentData.jam_mulai);
      formData.delete('jam_selesai');
      formData.append('jam_selesai', this.currentData.jam_selesai);
      formData.delete('alasan');
      formData.append('alasan', this.currentData.alasan);
      formData.delete("tanggal");
      formData.append("tanggal", this.formatDateLocal(this.currentData.tanggal));


      let employee_id = [];
      this.employees.forEach((item, index) => {
        employee_id.push(item.value)
      });
      formData.append('employee_id', employee_id.join(','));

      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      // CloseLoading();
      // return false;

      const api = base_url + '/v3/overtime/insert';
      const res = await axios.post(api, formData, { timeout });
      const data = res.data;

      if(data.status){
        AlertBottom(data.message);
        goPage('overtime');
        
      }else {
        AlertPopup2("error", "", data.message, true, 1500);
      }

    },

  },

};
</script>
